<template>
  <TaskEditModal/>
  <ShowTaskCommentModal/>
  <ShowCellCommentModal/>
  <ShowVehicleCommentModal/>
  <ShowTrailerCommentModal/>
  <ShowDriverCommentModal/>
  <SelectTrailerParkingModal/>
  <RangePlanCommentModal/>
  <button
    type="button"
    class="btn btn-primary btn-floating btn-lg"
    id="btn-back-to-top"
    ref="mybutton"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
  <Navbar/>
  <div class="my-1">
    <div id="toolbar" class="d-flex text-darker justify-content-evenly sticky-top" style="top: 57px;">
      <div>
        <span role="button" class="text-secondary text-decoration-none">
          <i class="fas fa-search"></i>
          <span v-if="isSearchVisible" @click="init(true, true)" class="text-danger fw-bold">
            Zamknij wyszukiwanie
          </span>
          <span v-if="!isSearchVisible" @click="isSearchVisible = true; toolbarHeightTop = 120">Szukaj</span>
        </span>
        <div v-if="isSearchVisible">
          <input v-model="searchText" type="search" class="form-control" id="searchTasksInp" placeholder="Wyszukaj w panelu" @input="searchValue">
        </div>
      </div>
      <button
        id="refresh-button"
        class="bg-white border-0"
        :class="{ 'text-primary': !refreshing, 'text-secondary': refreshing }"
        @click="refreshCalendar"
        :disabled="refreshing"
      >
        <i class="fas fa-sync"></i>
        <span v-if="!refreshing">
          Odśwież
        </span>
        <span v-else>
          Wczytuję...
        </span>
      </button>
    </div>
    <hr class="m-0" id="calendar-divider">
    <div id="heading-bar" class="row my-1">
      <div class="d-flex justify-content-start align-items-center">
        <h5 class="fw-bold mb-0 ms-1">
          PANEL ZADAŃ
        </h5>
        <div class="text-sm ms-5">
          <input type="date" class="form-control" v-model="date" ref="selectedDate" @change="populateUI('none', false)">
        </div>
        <div class="text-sm mx-3 d-none d-lg-block"></div>
        <div class="text-sm mx-3 d-none d-lg-block"></div>
        <div class="text-sm mx-3 d-none d-lg-block"></div>
      </div>
    </div>
    <table class="table table-responsive overflow-scroll" :class="{ 'minified-calendar': !isHorizontallyExpanded, 'maximized-calendar': isHorizontallyExpanded }">
      <thead id="calendar-heading">
      <tr class="sticky-top" :style="`top: ${toolbarHeightTop}px;`">
        <td
          role="button"
          id="height-marker"
          class="heading-bg p-2 rounded border border-white"
          style="width: 110px;"
          @click="sortVehicles"
        >
          Ciągnik
          <i class="fas fa-sort"></i>
        </td>
        <td class="heading-bg p-2 rounded border border-white" style="width: 110px">
          Naczepa
        </td>
        <td class="heading-bg p-2 rounded border border-white" style="width: 150px;">
          Kierowca
          <span v-if="!isHorizontallyExpanded" role="button" @click="toggleUIWidth(true)">
            <i class="fas fa-arrow-right"></i>
          </span>
        </td>
        <td v-if="isHorizontallyExpanded" class="heading-bg p-2 rounded border border-white" style="width: 250px;">
          <span role="button" @click="toggleUIWidth(false)">
            <i class="fas fa-arrow-left"></i>
          </span>
          Tryb pracy
        </td>
        <td :class="{ 'd-none': !activeDates.includes(date) }" v-for="date in dates" :key="date" class="heading-bg p-2 rounded border border-white user-select-none" style="min-width: 200px;">
          <span role="button" @click="populateUI('left')" v-if="date === activeDates[0]">
            <i class="fas fa-arrow-left"></i>
          </span>
          {{ date }}
          <span v-if="date === activeDates[showNextDayMovementArrowAt]" role="button" @click="populateUI('right')">
            <i class="fas fa-arrow-right"></i>
          </span>
        </td>
      </tr>
      </thead>
      <tbody>
      <VehicleOrdered :is-horizontally-expanded="isHorizontallyExpanded" :dates="dates"/>
      </tbody>
    </table>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import VehicleOrdered from '@/components/TasksCalendar/VehicleOrdered'
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'
import TaskEditModal from '@/components/TasksCalendar/Modals/TaskEditModal.vue'
import ShowTaskCommentModal from '@/components/TasksCalendar/Modals/ShowTaskCommentModal.vue'
import ShowCellCommentModal from '@/components/TasksCalendar/Modals/ShowCellCommentModal.vue'
import 'leaflet-routing-machine'
import L from 'leaflet'
import axios from 'axios'
import Swal from 'sweetalert2'
import notDisplayOnMapAcronyms from '@/modules/map/notDisplayOnMapAcronyms'
import ShowVehicleCommentModal from '@/components/TasksCalendar/Modals/ShowVehicleCommentModal.vue'
import ShowTrailerCommentModal from '@/components/TasksCalendar/Modals/ShowTrailerCommentModal.vue'
import ShowDriverCommentModal from '@/components/TasksCalendar/Modals/ShowDriverCommentModal.vue'
import SelectTrailerParkingModal from '@/components/TasksCalendar/Modals/SelectTrailerParkingModal.vue'
import RangePlanCommentModal from '@/components/TasksCalendar/Modals/RangePlanCommentModal.vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Index',
  components: { RangePlanCommentModal, SelectTrailerParkingModal, ShowDriverCommentModal, ShowTrailerCommentModal, ShowVehicleCommentModal, ShowCellCommentModal, ShowTaskCommentModal, TaskEditModal, VehicleOrdered, Navbar },
  data () {
    return {
      axiosConfig: { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } },
      isHorizontallyExpanded: false,
      browserZoomLevel: 100,
      windowInnerWidth: window.innerWidth,
      isSearchVisible: false,
      isMapVisible: false,
      searchText: '',
      rowClasses: {
        leftRowClass: 'col-3',
        rightRowClass: 'col-8'
      },
      vehiclesAscOrdering: true,
      date: new Date().toISOString().split('T')[0],
      dates: [],
      dateVector: 0,
      rowId: 0,
      mapTop: 0,
      refreshing: false,
      currentTask: null,
      eventKinds: eventKinds,
      map: null,
      routingMachine: null,
      waterLineRouting: null,
      endRouting: null,
      changesWaypointsKeys: [],
      waterWaypointsKeys: [],
      vehicleMarker: null,
      toolbarHeightTop: 81,
      moment: moment,
      showNextDayMovementArrowAt: 4
    }
  },
  computed: {
    ...mapGetters({
      activeDates: 'getCalendarActiveDates'
    })
  },
  created () {
    emitter.on(eventKinds.calendarMoved, () => {
      this.isMapVisible = false
    })

    window.addEventListener('scroll', this.scrollFunction)
    window.addEventListener('resize', this.detectResize)
    this.init()
  },
  mounted () {
    this.$el.addEventListener('keydown', this.moveCalendarByArrows)
  },
  beforeUnmount () {
    this.$el.removeEventListener('keydown', this.moveCalendarByArrows)
  },
  methods: {
    refreshCalendar () {
      this.refreshing = true
      emitter.emit('calendarRefreshed')
      setTimeout(() => this.refreshing = false, 1200)
    },

    init (preserveCalendarState = false, closingSearch = false) {
      this.refreshing = true
      this.$store.commit('setInitialCalendarLoading', true)
      this.searchText = ''
      this.isSearchVisible = false
      this.toolbarHeightTop = 81

      if (closingSearch) {
        emitter.emit('searchClosed')
        this.closeMapService()
      }

      this.populateUI('none', preserveCalendarState)
      this.refreshing = false
    },

    moveCalendarByArrows (e) {
      if (e.code === 'ArrowLeft' && !this.isSearchVisible) {
        this.populateUI('left')
      } else if (e.code === 'ArrowRight' && !this.isSearchVisible) {
        this.populateUI('right')
      }
    },

    searchValue () {
      setTimeout(() => {
        this.closeMapService()
        emitter.emit('searchTyped', { searchText: this.searchText.trim() })
      }, 1500)
    },

    getDateOffset (offset) {
      const today = new Date()
      today.setDate(today.getDate() + offset)
      return today.toISOString().split('T')[0]
    },

    getActiveDateArray () {
      const activeDateArray = []
      const loopStart = this.isHorizontallyExpanded ? -3 : -2
      const loopEnd = this.isHorizontallyExpanded ? 3 : 2

      for (let i = loopStart; i <= loopEnd; i++) {
        const dateIndex = this.dateVector + i
        activeDateArray.push(this.getDateOffset(dateIndex))
      }

      return activeDateArray
    },

    populateUI (changeDirection = 'none', preserveCalendarState = false) {
      if (changeDirection === 'left') {
        this.dateVector--
      } else if (changeDirection === 'right') {
        this.dateVector++
      }

      if (changeDirection === 'none') {
        this.dates = []

        const currentMoment = moment()
        const selectedMoment = moment(this.date)
        this.dateVector = selectedMoment.diff(currentMoment, 'days')

        for (let i = -30; i <= 30; i++) {
          this.dates.push(this.getDateOffset(this.dateVector + i))
        }
      }

      const activeDates = this.getActiveDateArray()

      this.dates = this.dates.filter((value, index, array) => array.indexOf(value) === index)
      this.$store.commit('setCalendarActiveDates', activeDates)
      emitter.emit(eventKinds.calendarMoved, { isSearchVisible: this.isSearchVisible, dates: activeDates })
    },

    initMapService (task, rowId, vehicleId, toggleMap = true) {
      if (!this.isMapVisible) {
        this.rowId = rowId
      }

      this.waterWaypointsKeys = []
      this.changesWaypointsKeys = []
      this.currentTask = task

      if (toggleMap) {
        this.isMapVisible = !this.isMapVisible
      }

      this.toggleRowHeight(this.rowId, this.isMapVisible)

      if (!this.map) {
        this.map = L.map(`map-${this.rowId}`, {
          zoom: 13,
          minWidth: 1500,
          maxWidth: 3000
        })

        this.map.invalidateSize()
      }

      L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(this.map)

      const wayPoints = []
      let stoppages = task.stoppages

      if (task.changes.length > 0) {
        stoppages = task.stoppagesAndChanges
        stoppages.map((s, k) => {
          if (s.type === 1) {
            this.changesWaypointsKeys.push(k)
          }

          wayPoints.push(L.latLng(s.latitude, s.longitude))
          if (notDisplayOnMapAcronyms.includes(s.acronym)) {
            this.waterWaypointsKeys.push(k)
          }
        })
      } else {
        stoppages.map((s, k) => {
          if (!s.place) {
            Swal.fire({
              title: `Adres o skrócie "${s.acronym}" nie istnieje`,
              icon: 'info',
              showConfirmButton: true,
              confirmButtonText: 'Dodaj ten adres',
              showCancelButton: true,
              cancelButtonText: 'Anuluj'
            }).then(r => {
              if (r.isConfirmed) {
                return this.$router.push(`/miejsca/dodaj/${s.acronym}`)
              }
            })
          }

          wayPoints.push(L.latLng(s.place.positionLatitude, s.place.positionLongitude))

          if (notDisplayOnMapAcronyms.includes(s.acronym)) {
            this.waterWaypointsKeys.push(k)
          }
        })
      }

      const throughWaterAcronymsKeys = []

      const startWayPoints = wayPoints
      const throughWaterWayPoints = []
      const endWayPoints = []

      stoppages.map((s, k) => {
        if (notDisplayOnMapAcronyms.includes(s.acronym)) {
          throughWaterAcronymsKeys.push(k)
        }
      })

      if (throughWaterAcronymsKeys.length === 2) {
        startWayPoints.map((wp, k) => {
          if (k === throughWaterAcronymsKeys[0]) {
            throughWaterWayPoints.push(startWayPoints[k])
            throughWaterWayPoints.push(startWayPoints[k + 1])
          }

          if (k >= throughWaterAcronymsKeys[1]) {
            endWayPoints.push(wp)
          }
        })

        startWayPoints.splice(throughWaterAcronymsKeys[0] + 1)
      }

      let secondWayPointIsChange = false

      if (wayPoints.length === 1) {
        const changeWayPoint = L.latLng(task.changes[0].latitude, task.changes[0].longitude);
        wayPoints.push(changeWayPoint)

        secondWayPointIsChange = true
      }

      this.routingMachine = L.Routing.control({
        waypoints: wayPoints,
        show: false,
        routeWhileDragging: false,
        lineOptions: {
          addWaypoints: false,
          styles: [{ color: '#ff1a1a' }]
        },
        createMarker: (i, start, n) => (this.waterWaypointsKeys[0] < i) ? null : L.marker(start.latLng, {
          icon: L.icon(
            {
              iconUrl: this.changesWaypointsKeys.includes(i) || (i === 1 && secondWayPointIsChange) ? require('@/assets/P.svg') : require(`@/assets/stoppages/${i + 1}.svg`),
              iconSize: [40, 40]
            })
        })
      }).addTo(this.map)

      this.map.invalidateSize()

      if (throughWaterAcronymsKeys.length === 2) {
        this.waterLineRouting = new L.Polyline(throughWaterWayPoints, {
          color: 'blue'
        }).addTo(this.map)

        this.endRouting = L.Routing.control({
          waypoints         : endWayPoints,
          show              : false,
          routeWhileDragging: false,
          lineOptions       : {
            addWaypoints: false,
            styles: [{ color: '#ff1a1a' }]
          },
          createMarker: (i, start, n) => (this.waterWaypointsKeys[0] > (i + 2 + endWayPoints.length)) ? null : L.marker(start.latLng, {
            icon: L.icon(
              {
                iconUrl: this.changesWaypointsKeys.includes(i) ? require('@/assets/P.svg') : require(`@/assets/stoppages/${i + endWayPoints.length + 1}.svg`),
                iconSize: [40, 40]
              })
          })
        }).addTo(this.map)
      }

      const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }, params: { period: 24 } }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${task.vehicleId}/Route`, axiosConfig).then(r => {
        if (r.data.route.length > 0) {
          let iconUrl = ''
          const asimuth = r.data.route[r.data.route.length - 1].asimuth

          if (asimuth < 45) {
            iconUrl = require('@/assets/vehicle/N.svg')
          } else if (asimuth >= 45 && asimuth < 90) {
            iconUrl = require('@/assets/vehicle/NE.svg')
          } else if (asimuth >= 90 && asimuth < 135) {
            iconUrl = require('@/assets/vehicle/E.svg')
          } else if (asimuth >= 135 && asimuth < 180) {
            iconUrl = require('@/assets/vehicle/SE.svg')
          } else if (asimuth >= 180 && asimuth < 225) {
            iconUrl = require('@/assets/vehicle/S.svg')
          } else if (asimuth >= 225 && asimuth < 270) {
            iconUrl = require('@/assets/vehicle/SW.svg')
          } else if (asimuth >= 270 && asimuth < 315) {
            iconUrl = require('@/assets/vehicle/W.svg')
          } else if (asimuth >= 315) {
            iconUrl = require('@/assets/vehicle/NW.svg')
          }

          if (r.data.route[r.data.route.length - 1].routePointType === 'ParkingOnEngine' || r.data.route[r.data.route.length - 1].routePointType === 'Parking') {
            iconUrl = require('@/assets/vehicle/postoj.svg')
          }

          if (this.map && this.vehicleMarker) {
            this.map.removeLayer(this.vehicleMarker)
            this.vehicleMarker = null
          }

          if (iconUrl !== '') {
            const vehicleMarkerIcon = L.icon({
              iconUrl: iconUrl,
              iconSize: [30, 30]
            })

            this.vehicles = L.marker([r.data.route[r.data.route.length - 1].positionLatitude, r.data.route[r.data.route.length - 1].positionLongitude], { icon: vehicleMarkerIcon }).addTo(this.map)
          }
        }
      })
    },

    closeMapService () {
      this.isMapVisible = false
      this.toggleRowHeight(this.rowId, this.isMapVisible)
      if (this.routingMachine) {
        this.routingMachine.setWaypoints([])
      }

      if (this.map) {
        this.map.remove()
        this.map = null
      }
    },

    toggleUIWidth (isExpanded) {
      this.isHorizontallyExpanded = isExpanded
      this.$store.commit('setCalendarActiveDates', this.getActiveDateArray())

      if (isExpanded) {
        this.rowClasses.leftRowClass = 'col-6'
        this.rowClasses.rightRowClass = 'col-5'
        this.showNextDayMovementArrowAt = 6
        emitter.emit('driversRequested')
      } else {
        this.rowClasses.leftRowClass = 'col-3'
        this.rowClasses.rightRowClass = 'col-8'
        this.showNextDayMovementArrowAt = 4
      }
    },

    detectResize () {
      this.isHorizontallyExpanded = Math.round(window.devicePixelRatio * 100) < 80
      this.windowInnerWidth = window.innerWidth
      this.toggleUIWidth(this.isHorizontallyExpanded)
    },
    toggleRowHeight (rowId, isMapVisible = false) {
      const mapContainerHeight = 520

      if (isMapVisible) {
        if (document.getElementById(`row-tr-${rowId}`)) {
          document.getElementById(`row-tr-${rowId}`).style.height = `calc(${mapContainerHeight}px + 50px)`
        }
      } else {
        if (document.getElementById(`row-tr-${rowId}`)) {
          document.getElementById(`row-tr-${rowId}`).style.height = '60px'
        }
      }
    },
    sortVehicles () {
      this.vehiclesAscOrdering = !this.vehiclesAscOrdering
      if (this.vehiclesAscOrdering) {
        this.vehicles = this.vehicles.sort((a, b) => a.plateNumber > b.plateNumber ? 1 : -1)
      } else {
        this.vehicles = this.vehicles.sort((a, b) => b.plateNumber > a.plateNumber ? 1 : -1)
      }
    },
    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'block'
        }
      } else {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'none'
        }
      }
    },
    backToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped>
table {
  height: 1px;
}

#searchTasksInp {
  min-width: 600px;
}

.minified-calendar {
  min-width: 1500px;
}

.maximized-calendar {
  min-width: 1900px;
}
#map {
  height: 300px;
}


.text-sm {
  font-size: .8rem;
}

.text-darker {
  color: #bbb;
}

.heading-bg {
  background-color: #d6d7d8;
}

#btn-back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
}

.sticky-top {
  z-index: 100;
}

.swal2-container{
  z-index: 30000000 !important;
}

#toolbar {
  background: white;
}

@media (max-width: 1500px) {
  #toolbar, #calendar-divider, #heading-bar {
    min-width: 1500px;
  }
}
</style>
